<template>
  <div
    class="py-5 px-3 rounded-md mx-2"
    style="max-width: 100%; margin: 0 auto"
  >
    <h1 class="fs-3 fw-bold">
      Mars Gaming Platform - Privacy Policy
    </h1>

    <p class="text-secondary">
      At Mars Gaming, your privacy is a top priority. This policy outlines how
      we collect, use, and protect your personal information when you use our
      platform.
    </p>

    <h2 class="fs-4 fw-semibold">1. Information We Collect</h2>
    <p class="text-secondary">
      We may collect the following information when you use Mars Gaming:
    </p>
    <ul class="list-unstyled ms-4">
      <li>
        <strong>Personal Details:</strong> Name, email address, and username.
      </li>
      <li>
        <strong>Game Data:</strong> In-game activity, scores, achievements, and
        preferences.
      </li>
      <li>
        <strong>Technical Data:</strong> Device type, IP address, and usage
        statistics.
      </li>
    </ul>

    <h2 class="fs-4 fw-semibold">2. How We Use Your Information</h2>
    <p class="text-secondary">We use your information to:</p>
    <ul class="list-unstyled ms-4">
      <li>Improve your gaming experience and provide personalized content.</li>
      <li>Manage your account and provide customer support.</li>
      <li>Enhance the platform’s security and functionality.</li>
    </ul>

    <h2 class="fs-4 fw-semibold">3. Data Sharing</h2>
    <p class="text-secondary">
      We do not sell your personal information. We may share data with trusted
      third-party service providers for analytics, payment processing, and
      platform enhancements, but only as necessary.
    </p>

    <h2 class="fs-4 fw-semibold">4. Security</h2>
    <p class="text-secondary">
      We implement strong security measures to protect your data from
      unauthorized access. However, no system is completely secure, and we
      cannot guarantee the absolute safety of your information.
    </p>

    <h2 class="fs-4 fw-semibold">5. Your Rights</h2>
    <p class="text-secondary">
      You can access, update, or delete your personal information at any time by
      visiting your account settings. You may also request to close your account
      by contacting our support team.
    </p>

    <h2 class="fs-4 fw-semibold">6. Changes to This Policy</h2>
    <p class="text-secondary">
      We may update this policy from time to time. Any changes will be posted on
      this page, and we encourage you to review the policy regularly.
    </p>
  </div>
</template>

<script>
export default {
  name: "PrivacyView",
};
</script>
